<template>
  
</template>

<script>
  export default {
    name: 'KITCHENSINK',
    mounted() {
      if (this.$root.config_ && this.$root.config_.context === 'Documents') {
        // Pass the token to vuex
        this.$store.commit("authorize", this.$root.config_.token);
        this.$router.push({ path: '/document-browser/' + this.$root.config_.id})
      }
    }
  }
</script>
